export const ACTION_ITEM_OWNER = {
	YOU: 'you',
	STUDENT: 'student',
}

export function mapOwnerTypeFromApi(ownerType) {
	if (ownerType === 'student') return ACTION_ITEM_OWNER.STUDENT
	return ACTION_ITEM_OWNER.YOU
}

export function mapOwnerTypeToApi(ownerType) {
	if (ownerType === ACTION_ITEM_OWNER.STUDENT) return 'student'
	return 'counselor'
}

export function mapActionItemFromApi(item, { saveStatus = 'idle' } = {}) {
	const dueHint = item.dueHint == null ? null : String(item.dueHint).trim() || null
	return {
		id: String(item.id),
		text: String(item.text || ''),
		ownerType: mapOwnerTypeFromApi(item.ownerType),
		ownerLabel: item.ownerLabel ?? null,
		dueHint,
		status: item.status === 'done' ? 'done' : 'open',
		sortOrder: Number(item.sortOrder) || 0,
		source: item.source || 'manual',
		saveStatus,
		saveError: null,
	}
}

export function clonePersistedActionItem(item) {
	return {
		...item,
		saveStatus: item.saveStatus || 'idle',
		saveError: item.saveError || null,
	}
}

export function buildActionItemCreatePayload(draft, { studentName = '' } = {}) {
	const ownerType = mapOwnerTypeToApi(draft.ownerType)
	const ownerLabel =
		ownerType === 'student'
			? String(studentName || draft.ownerLabel || '').split(' ')[0] || 'Student'
			: 'You'

	return {
		text: String(draft.text || '').trim(),
		ownerType,
		ownerLabel,
	}
}
